import React from 'react'
import { Link } from '@morningtrain/react-navigation'
import { Env } from '@morningtrain/helpers'
import * as Auth from '@morningtrain/react-auth'

export default function EditFormActions (props) {
  const { storePermission } = props

  return (
    <div className='form-actions'>
      <Link route={Env.get('page.parent')} label='Tilbage' />
      {(storePermission) ? (
        <Auth.CanUseModel permission={storePermission}>
          <input type='submit' value='Gem' />
        </Auth.CanUseModel>
      ) : (
        <input type='submit' value='Gem' />
      )}
    </div>
  )
}
